var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{staticClass:"main-nav-header",attrs:{"id":"main-header","app":"","flat":"","height":"100","absolute":_vm.isScrolling}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }